import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthenticationGuard } from "@bndes/bndes-ux4/bn-seguranca";
import { AgenteFinanceiroResolver } from 'src/app/shared/resolvers/agente-financeiro.resolver';
import { EscolhaModalidadeGuard } from 'src/app/interceptors/escolha-modalidade.guard';
import { EmpresasBloqueadasComponent } from './empresas-bloqueadas.component';
import { SolicitacoesHonraExportacaoComponent } from './solicitacoes-honra-exportacao.component';
import { ExportacaoParametrosComponent } from './exportacao-parametros.component';

const routes: Routes = [
  {
    path: 'exportacao/solicitacoes-honra-exportacao',
    component: SolicitacoesHonraExportacaoComponent,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    resolve: {
    	agentes: AgenteFinanceiroResolver
    }, 
    data: { canReuse: false }
  },
  {
    path: 'exportacao/empresas-bloqueadas',
    component: EmpresasBloqueadasComponent,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    resolve: {
    	agentes: AgenteFinanceiroResolver
    }, 
    data: { canReuse: false }
  },
  // tem que ficar por ultimo
  {
    path: 'exportacao/:opcaoExportacao',
    component: ExportacaoParametrosComponent,
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    data: { canReuse: false }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ExportacaoRoutingModule { }
